"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes[ButtonTypes["Submit"] = 1] = "Submit";
    ButtonTypes[ButtonTypes["Icon"] = 2] = "Icon";
    ButtonTypes[ButtonTypes["Anchor"] = 3] = "Anchor";
})(ButtonTypes || (ButtonTypes = {}));
exports.default = ButtonTypes;
